import { _Api } from "./core";
var geocoderAPi = '/provider/geocoder';
export var ROUTES = {
  DIAGNOSTIC: '/diagnostics/:id/collector',
  // ---- QUESTIONS
  QUESTIONS: '/questions/:id/collector',
  CONDITION_TYPES: '/condition_types',
  BLOCS: '/blocs/:id/collector',
  TYPES: '/types',
  NEXT_QUESTION: '/diagnostics/next_question',
  // GEOLOCALIZATION
  ADDRESS_EXIST: "".concat(geocoderAPi, "/suggestions"),
  REVERSE_GEOCODE: "".concat(geocoderAPi, "/reverse-geocoding"),
  GEOCODE: "".concat(geocoderAPi, "/geocoding")
};

/**
 * @todo Transform in singleton to initialize it with token in all app.
 * Contains all functions used to request the API
 */
var Api = _Api;
export default Api;